import React from 'react';

export const TASK_STATUS_STYLES = {
  COMPLETED: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200',
  IN_PROGRESS: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
  PICK_TODAY: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/50 dark:text-indigo-200',
  PENDING: 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200',
  CANCELLED: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
};

export const formatTaskStatusLabel = (status) => {
  if (!status) return 'Task';
  return status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

export const TaskStatusIcon = ({ status, className = 'w-4 h-4' }) => {
  switch (status) {
    case 'COMPLETED':
      return (
        <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    case 'IN_PROGRESS':
      return (
        <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    case 'PICK_TODAY':
      return (
        <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      );
    case 'PENDING':
      return (
        <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    default:
      return (
        <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      );
  }
};

export const TaskStatusRow = ({ task, compact = false }) => {
  const status = task?.status || 'PENDING';
  const badgeClass = TASK_STATUS_STYLES[status] || TASK_STATUS_STYLES.PENDING;

  return (
    <div className={`flex items-start gap-2 ${compact ? 'py-1' : 'py-2'}`}>
      <span className={`flex-shrink-0 mt-0.5 inline-flex items-center justify-center w-7 h-7 rounded-full ${badgeClass}`}>
        <TaskStatusIcon status={status} className="w-3.5 h-3.5" />
      </span>
      <div className="min-w-0 flex-1">
        <p className={`font-medium text-gray-900 dark:text-white leading-snug ${compact ? 'text-xs' : 'text-sm'}`}>
          {task?.title || 'Task'}
        </p>
        <div className="flex flex-wrap items-center gap-2 mt-0.5">
          <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide ${badgeClass}`}>
            {formatTaskStatusLabel(status)}
          </span>
          {task?.minutes != null && task.minutes > 0 && (
            <span className="text-[10px] text-gray-500 dark:text-gray-400 tabular-nums">
              {task.minutes}m
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
